import { DocumentIconProps } from "../types";
import { getFileKind } from "../utils/fileHelpers";
import { PowerPointIcon } from "./PowerPointIcon";
import { WordIcon } from "./WordIcon";

interface DocumentTypeIconProps extends DocumentIconProps {
  filename?: string;
}

export const DocumentTypeIcon = ({
  filename,
  ...iconProps
}: DocumentTypeIconProps) => {
  return getFileKind(filename) === "word" ? (
    <WordIcon {...iconProps} />
  ) : (
    <PowerPointIcon {...iconProps} />
  );
};
